import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { KundeService } from '../service';

@Component({
  selector: 'fa-kt-kunde-detail',
  templateUrl: './kunde-detail.component.html',
  styleUrls: ['./kunde-detail.component.css'],
})
export class KundeDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public kunde: KundeService) {}
}
